import {
  Module,
  VuexModule,
  Action,
  Mutation,
  getModule
} from 'vuex-module-decorators'
import Vue from 'vue'
import axios from 'axios'

import store from '@/store'
import dashboardModule from '@/store/dashboard'
import listModule from '@/store/list'
import whitelabelModule from '@/store/whitelabel'
import { PromotionCode } from '@/types/PromotionCode'
import { Whitelabel } from '@/types/Whitelabel'

const name = 'promotioncode'

@Module({
  namespaced: true,
  dynamic: true,
  name,
  store
})
class PromotionCodeModule extends VuexModule {
  private currentPromotionCode?: PromotionCode
  private allPromotionCodes: PromotionCode[] = []

  private get whitelabel(): Whitelabel {
    return whitelabelModule.whitelabel
  }

  get promotionCode(): PromotionCode | undefined {
    return this.currentPromotionCode
  }

  get promotionCodes(): PromotionCode[] {
    return this.allPromotionCodes
  }

  @Mutation
  setCurrentPromotionCode(payload: PromotionCode) {
    Vue.set(this, 'currentPromotionCode', payload)
  }

  @Mutation
  setAllPromotionCodes(payload: PromotionCode[]) {
    Vue.set(this, 'allPromotionCodes', payload)
  }

  @Action({ rawError: true })
  async fetchAll(params: {
    limit: number
    q?: string
    page?: number
    sortBy?: string
    sortDesc?: boolean
  }) {
    try {
      const { data } = await axios.get(
        `/admin/${this.whitelabel.slug}/promotionCode/list`,
        {
          params
        }
      )
      this.context.commit('setAllPromotionCodes', data.promotionCodes)
    } catch (error) {
      dashboardModule.newError('Promotion Codes konnten nicht geladen werden')
    }
  }

  @Action({ rawError: true })
  async create(promotionCode: any) {
    try {
      const { data } = await axios.post(
        `/admin/${promotionCode.whitelabel}/promotionCode`,
        promotionCode
      )
      this.context.commit('setCurrentPromotionCode', data)
      this.fetchAll({ limit: listModule.perPage })
      dashboardModule.newMessage('Promotion Code wurde erfolgreich erstellt')
    } catch (error) {
      dashboardModule.newError('Promotion Code konnte nicht erstellt werden')
    }
  }

  @Action({ rawError: true })
  async update(promotionCode: Partial<PromotionCode>) {
    try {
      const { data } = await axios.put(
        `/admin/${promotionCode.whitelabel}/promotionCode/${promotionCode._id}`,
        promotionCode
      )
      this.context.commit('setCurrentPromotionCode', data.promotionCode)
      this.fetchAll({ limit: listModule.perPage })
      dashboardModule.newMessage(
        'Promotion Code wurde erfolgreich aktualisiert'
      )
    } catch (error) {
      dashboardModule.newError(
        'Promotion Code konnte nicht aktualisiert werden'
      )
    }
  }

  @Action({ rawError: true })
  setPromotionCode(payload: PromotionCode) {
    this.context.commit('setCurrentPromotionCode', payload)
  }
}

export default getModule(PromotionCodeModule)
